"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelSCN = exports.deleteSCN = exports.revokeSCN = exports.getSCNReducer = void 0;
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
var doesObjHaveUndefinedValues_1 = __importDefault(require("common/utils/doesObjHaveUndefinedValues"));
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var firebase_1 = __importDefault(require("firebase"));
var app_1 = require("firebase/app");
var set_1 = __importDefault(require("lodash/fp/set"));
var sendApprovalNotification_1 = require("portal/utils/sendApprovalNotification");
var SendNotification_1 = require("portal/utils/SendNotification");
var getSCNReducer = function (router, t) { return function (state, action) {
    var _a, _b;
    var userId = (_b = (_a = (0, app_1.auth)().currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : "";
    var match = router.match;
    var SCNId = match.params.SCNId;
    switch (action.type) {
        case "init":
            return action.payload;
        case "update":
            if (action.payload.path === "SCNData.date") {
                return (0, set_1.default)(action.payload.path, action.payload.newValue, state);
            }
            return (0, set_1.default)(action.payload.path, action.payload.newValue, state);
        case "buttonClick":
            switch (action.data.action) {
                case "Approve": {
                    firebase_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    collectionsRef_1.approvalsRef.add({
                                        approvedAt: action.data.payload.approvedAt,
                                        createdAt: new Date(),
                                        updatedAt: new Date(),
                                        userId: userId,
                                        formId: state.SCNId,
                                        formType: "service-complete-note",
                                        approvalType: action.data.payload.approvalType,
                                        signatureURL: (_b = (_a = usersList_1.globalUsersData[userId]) === null || _a === void 0 ? void 0 : _a.signatureURL) !== null && _b !== void 0 ? _b : "",
                                    });
                                    return [4 /*yield*/, checkIfAllApproved(state.SCNId, state.SCNData.orderId, state, userId, action.data.payload.approvalType, transaction)];
                                case 1:
                                    _c.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                    })
                        .then(function () {
                        //   window.location.reload();
                    });
                    console.log({ state: state });
                    var nextStatus = checkNextStatus(action.data.payload.approvalType);
                    return __assign(__assign({}, state), { SCNData: __assign(__assign({}, state.SCNData), { status: nextStatus }) });
                }
                case "Save": {
                    firebase_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            transaction.update(collectionsRef_1.SCNsRef.doc(SCNId), (0, removeUndefined_1.default)(getSCNDataFromState(state)));
                            state.SCNItems.map(function (item, index) {
                                var data = createSCNItem(SCNId, item);
                                transaction.set(collectionsRef_1.SCNItemsRef.doc(item.id), (0, removeUndefined_1.default)(__assign(__assign({}, data), { index: index })));
                            });
                            return [2 /*return*/];
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                    })
                        .catch(function (error) {
                        console.log(error);
                        antd_1.message.error(error);
                    });
                    break;
                }
                case "Cancel": {
                    firebase_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, exports.cancelSCN)(state.SCNId, transaction)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        officeId: state.SCNData.deliveryLocation,
                                        projectId: state.SCNData.projectId,
                                        docType: "service-complete-note",
                                        docId: state.SCNId,
                                        ref: (_a = state.SCNData.SCNNumber) !== null && _a !== void 0 ? _a : "",
                                        docDesc: "",
                                        action: "cancelled",
                                    })];
                                case 1:
                                    _b.sent();
                                    antd_1.message.success(t("alerts.success"));
                                    window.location.reload();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    break;
                }
                case "Publish": {
                    var SCNData_1 = getSCNDataFromState(state);
                    if ((0, doesObjHaveUndefinedValues_1.default)(SCNData_1)) {
                        antd_1.message.error(t("alerts.invalidFormMsg"));
                        return __assign(__assign({}, state), { triedSubmitting: true });
                    }
                    state.SCNItems.map(function (item) {
                        var itemData = createSCNItem(SCNId, item);
                        if ((0, doesObjHaveUndefinedValues_1.default)(itemData)) {
                            antd_1.message.error(t("alerts.invalidFormMsg"));
                            return __assign(__assign({}, state), { triedSubmitting: true });
                        }
                    });
                    firebase_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!!(0, doesObjHaveUndefinedValues_1.default)(SCNData_1)) return [3 /*break*/, 2];
                                    transaction.update(collectionsRef_1.SCNsRef.doc(state.SCNId), __assign({}, SCNData_1));
                                    state.SCNItems.map(function (item) {
                                        var itemData = createSCNItem(SCNId, item);
                                        if (!(0, doesObjHaveUndefinedValues_1.default)(itemData)) {
                                            transaction.update(collectionsRef_1.SCNItemsRef.doc(item.id), __assign({}, itemData));
                                        }
                                    });
                                    transaction.update(collectionsRef_1.SCNsRef.doc(state.SCNId), {
                                        status: "pendingScnReceivedAndCheckedByApproval",
                                        requestedAt: new Date(),
                                        requestedBy: firebase_1.default.auth().currentUser.uid,
                                    });
                                    return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                                            officeId: state.SCNData.deliveryLocation,
                                            approval: "SCNReceivedAndCheckedByApproval",
                                            projectId: state.SCNData.projectId,
                                            amount: 0,
                                            docId: state.SCNId,
                                            docType: "service-complete-note",
                                            ref: state.SCNData.SCNNumber,
                                            userId: userId,
                                            docDesc: "",
                                            action: "approvalPending",
                                        })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/, __assign(__assign({}, state), { triedSubmitting: true })];
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, antd_1.message.success(t("alerts.success"))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        window.location.reload();
                    })
                        .catch(function (e) {
                        console.error(e);
                        antd_1.message.error(t("alerts.error"));
                    });
                    break;
                }
                case "Revoke": {
                    firebase_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, exports.revokeSCN)(state.SCNId, state.SCNData.orderId, transaction)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        officeId: state.SCNData.deliveryLocation,
                                        projectId: state.SCNData.projectId,
                                        docType: "service-complete-note",
                                        docId: state.SCNId,
                                        ref: (_a = state.SCNData.SCNNumber) !== null && _a !== void 0 ? _a : "",
                                        docDesc: "",
                                        action: "revoked",
                                    })];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                    })
                        .then(function () {
                        window.location.reload();
                    })
                        .catch(function () {
                        antd_1.message.error(t("alerts.error"));
                    });
                    break;
                }
            }
    }
    return state;
}; };
exports.getSCNReducer = getSCNReducer;
var getSCNDataFromState = function (state) {
    var _a;
    return __assign(__assign({}, state.SCNData), { date: (_a = state.SCNData.date) === null || _a === void 0 ? void 0 : _a.toDate(), contractNo: state.SCNData.contractNo, consigneName: state.SCNData.consigneName, supplierName: state.SCNData.supplierName, supplierAddress: state.SCNData.supplierAddress });
};
var createSCNItem = function (SCNId, item) {
    return __assign(__assign({}, item), { SCNId: SCNId, 
        // itemNo: item.itemNo,
        serviceOrdered: item.serviceOrdered, productDescription: item.productDescription, productName: item.productName, productId: item.productId, unitId: item.unitId, serviceReceived: item.serviceReceived, remarks: item.remarks });
};
function checkIfAllApproved(SCNId, orderId, state, userId, approvalType, transaction) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var waitingFor;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(approvalType === "approvedBy")) return [3 /*break*/, 2];
                    transaction.update(collectionsRef_1.SCNsRef.doc(SCNId), { status: "approved" });
                    transaction.update(collectionsRef_1.ordersRef.doc(state.SCNData.orderId), {
                        status: "postSCNs",
                    });
                    return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                            officeId: state.SCNData.deliveryLocation,
                            projectId: state.SCNData.projectId,
                            docType: "service-complete-note",
                            docId: state.SCNId,
                            ref: (_a = state.SCNData.SCNNumber) !== null && _a !== void 0 ? _a : "",
                            docDesc: "",
                            action: "approved",
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2:
                    transaction.update(collectionsRef_1.SCNsRef.doc(SCNId), {
                        status: "pendingScnApprovedByApproval",
                    });
                    waitingFor = "SCNApprovedByApproval";
                    return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                            officeId: state.SCNData.deliveryLocation,
                            approval: waitingFor !== null && waitingFor !== void 0 ? waitingFor : "",
                            projectId: state.SCNData.projectId,
                            amount: 0,
                            docId: SCNId,
                            docType: "service-complete-note",
                            ref: state.SCNData.SCNNumber,
                            userId: state.SCNData.requestedBy,
                            docDesc: "",
                            action: "approvalPending",
                        })];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function checkNextStatus(approvalType) {
    var status;
    if (approvalType === "approvedBy") {
        status = "approved";
    }
    else {
        status = "pendingScnApprovedByApproval";
    }
    return status;
}
var revokeSCN = function (SCNId, orderId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                transaction.update(collectionsRef_1.SCNsRef.doc(SCNId), {
                    status: "draft",
                    requestedAt: firebase_1.default.firestore.FieldValue.delete(),
                    requestedBy: firebase_1.default.firestore.FieldValue.delete(),
                });
                transaction.update(collectionsRef_1.ordersRef.doc(orderId), { status: "preparingSCNs" });
                _b = (_a = Promise).all;
                return [4 /*yield*/, collectionsRef_1.approvalsRef.where("formId", "==", SCNId).get()];
            case 1: return [4 /*yield*/, _b.apply(_a, [(_e.sent()).docs.map(function (x) {
                        return transaction.delete(x.ref);
                    })])];
            case 2:
                _e.sent();
                _d = (_c = Promise).all;
                return [4 /*yield*/, collectionsRef_1.notificationsRef.where("docId", "==", SCNId).get()];
            case 3: return [4 /*yield*/, _d.apply(_c, [(_e.sent()).docs.map(function (x) {
                        return transaction.delete(x.ref);
                    })])];
            case 4:
                _e.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.revokeSCN = revokeSCN;
var deleteSCN = function (SCNId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, transaction.get(collectionsRef_1.SCNsRef.doc(SCNId))];
            case 1:
                data = (_c.sent()).data();
                if (data.status === "singedAndArchived" || data.status === "completed") {
                    throw new Error("you cannot delete singed form");
                }
                if (!(data.status === "pendingApprovals" || data.status === "approved")) return [3 /*break*/, 4];
                transaction.delete(collectionsRef_1.SCNsRef.doc(SCNId));
                _b = (_a = Promise).all;
                return [4 /*yield*/, collectionsRef_1.SCNsRef.where("SCNId", "==", SCNId).get()];
            case 2: return [4 /*yield*/, _b.apply(_a, [(_c.sent()).docs.map(function (x) {
                        return transaction.delete(x.ref);
                    })])];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.deleteSCN = deleteSCN;
var cancelSCN = function (SCNId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var data, _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, transaction.get(collectionsRef_1.SCNsRef.doc(SCNId))];
            case 1:
                data = (_e.sent()).data();
                if (data.status === "singedAndArchived" || data.status === "completed") {
                    throw new Error("you cannot delete singed form");
                }
                transaction.update(collectionsRef_1.SCNsRef.doc(SCNId), {
                    status: "canceled",
                    requestedAt: firebase_1.default.firestore.FieldValue.delete(),
                    requestedBy: firebase_1.default.firestore.FieldValue.delete(),
                });
                _b = (_a = Promise).all;
                return [4 /*yield*/, collectionsRef_1.approvalsRef.where("formId", "==", SCNId).get()];
            case 2: return [4 /*yield*/, _b.apply(_a, [(_e.sent()).docs.map(function (x) {
                        return transaction.delete(x.ref);
                    })])];
            case 3:
                _e.sent();
                _d = (_c = Promise).all;
                return [4 /*yield*/, collectionsRef_1.notificationsRef
                        .where("docId", "==", SCNId)
                        .where("action", "==", "approvalPending")
                        .get()];
            case 4: return [4 /*yield*/, _d.apply(_c, [(_e.sent()).docs.map(function (x) { return transaction.delete(x.ref); })])];
            case 5:
                _e.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.cancelSCN = cancelSCN;
